import { render, staticRenderFns } from "./wxapp.vue?vue&type=template&id=42238ea8&scoped=true"
import script from "./wxapp.vue?vue&type=script&lang=js"
export * from "./wxapp.vue?vue&type=script&lang=js"
import style0 from "./wxapp.vue?vue&type=style&index=0&id=42238ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42238ea8",
  null
  
)

export default component.exports